import { CocosConstants } from "../constants";
import { PlanManager } from "../cocosPlan";
import { Events, eventsManager, Floor, JSONSerializer, Listener } from "@rhinov/savane-js";



export class FloorController {

    roofUrl: string = CocosConstants.resourcesBasePath + '/resources/level_roof_';
    levelUpUrl: string = CocosConstants.resourcesBasePath + '/resources/level_up_';
    dotUrl: string = CocosConstants.resourcesBasePath + '/resources/yellowDot.png';
    floors: any = [];
    currentFloorName: string | null = null;
    hoverFloor: string | null = null;
    manualListener: Listener | null = null;

    // Listener listening to current floor changed event (initialised below)
    floorChangedListener: Listener | null = null;

    constructor () {
        this.manualListener = eventsManager.instance.addListener('MANUAL_FLOOR_INIT', (param: any) => {
            var floorList = param.getUserData().floors;
            this._initFloorCombo(floorList, param.getUserData().id);
        });

        this.floorChangedListener = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, (param: any) => {
            var floorList = PlanManager.getInstance().getAllFloor();
            this._initFloorCombo(floorList, param.getUserData().id);
        });

        eventsManager.instance.dispatch(Events.PLAN_FLOOR_CHANGED, PlanManager.getInstance().world.currentScene!.currentFloor);
    }
    

    // function allowing to sort the floors by height
    sortByHeight(a: Floor, b: Floor): number {
        if (a.height > b.height) {
            return -1;
        }
        else {
            if (a.height < b.height)
                return 1;
            else
                return 0;
        }
    };

    // Initialise floor management popup box
    _initFloorCombo(floorList: Floor[], setFloor: number) {
        // Empty floors global array
        this.floors = [];

        // Retrieve floor list and sort them
        var floors = floorList;
        floors.sort(this.sortByHeight);

        var nbAbove = 0;
        var nbBelow = 0;
        var nbFloors = floors.length;
        var i;
        var label;
        var hideDelete;

        // If more than one floor
        if (nbFloors > 1) {
            // Counting number of floor above and below
            for (i = 0; i < nbFloors; i++) {
                if (floors[i].height < 0) {
                    nbBelow--;
                }
                else {
                    if (floors[i].height > 0) {
                        nbAbove++;
                    }
                }
            }

            // Create floor entry for the floors global array to be used by the controller
            for (i = 0; i < nbFloors; i++) {
                // Floor name is RDC or Etage X
                label = (nbAbove === 0) ? 'RDC' : 'Étage ' + nbAbove;
                // We do not display the delete button ?
                hideDelete = ((i === 0 || i === (nbFloors - 1)) ? false : true);

                if (setFloor !== undefined && setFloor == floors[i].id) {
                    // this.changeFloor(floors[i].id, label);
                    this.currentFloorName = label;
                    (floors[i] as any).sufix = 'ON.png';
                }
                else {
                    if (setFloor === undefined && floors[i].height === 0) {
                        (floors[i] as any).sufix = 'ON.png';
                        this.currentFloorName = label;
                    }
                    else {
                        (floors[i] as any).sufix = 'OFF.png';
                    }
                }

                // We always hide the delete floor for the ground floor (0 height)
                if (floors[i].height === 0) {
                    hideDelete = true;
                }
                (floors[i] as any).hideDelete = hideDelete;
                (floors[i] as any).floorName = label;

                if (nbAbove > 0) {
                    (floors[i] as any).src = CocosConstants.resourcesBasePath + '/resources/level_up_';
                }
                else {
                    if (nbAbove === 0) {
                        (floors[i] as any).src = CocosConstants.resourcesBasePath + '/resources/level_0_';
                    }
                    else {
                        if (nbAbove < 0) {
                            (floors[i] as any).src = CocosConstants.resourcesBasePath + '/resources/level_down_';
                        }
                    }
                }
                nbAbove--;

                // Finally push floor into floors global array
                this.floors.push(floors[i]);
            }
        }
        else {
            // One floor, set floor name to RDC
            (floors[0] as any).floorName = 'RDC';
            (floors[0] as any).src = CocosConstants.resourcesBasePath + '/resources/level_0_';
            (floors[0] as any).sufix = 'ON.png';
            // We hide the delete button (not allowed to delete the ground floor)
            (floors[0] as any).hideDelete = true;

            // Push the floor into the floors array
            this.floors.push(floors[0]);

            // Set current floor name to the create floor
            this.currentFloorName = (floors[0] as any).floorName;
        }
    };

    downloadRhinovFloorFormat(floorId: number, planId: number) {
        //Export format and download it
        var floor = null;
        for (var i = 0; i < PlanManager.getInstance().world.currentScene!.floors.length; i++) {
            if (PlanManager.getInstance().world.currentScene!.floors[i].id === floorId) {
                floor = PlanManager.getInstance().world.currentScene!.floors[i];
                break;
            }
        }

        if (floor === null) {
            return;
        }

        var json = JSON.stringify(JSONSerializer.serializeEntity(floor));
        var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
        var downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'deliverable_' + planId + '_floor_' + (floor as any).floorName + '.rhinovfloor';
        downloadLink.click();
    };

    importRhinovFloorFormat(floorId: number) {
        let importFloorInput = document.getElementById('format-rhinovfloor-pick') as any;
        importFloorInput.floorToImportId = floorId;
        importFloorInput.value = null;
        importFloorInput.click();
    };

    // Destroy listeners when the controller is exited
    destroy() {
        eventsManager.instance.removeListener(this.manualListener!);
        eventsManager.instance.removeListener(this.floorChangedListener!);
    };

    /**
     * Remove a floor
     * @param floorId
     */
    deleteFloor(floorId: number) {
        // Send a message around the listener will delete the floor for us
        eventsManager.instance.dispatch(Events.FLOOR_DELETE, floorId);
    };

    /**
     * Swap 2 floors
     * @param floorA
     * @param floorB
     */
    swapFloor(floorIdA: number, floorIdB: number) {
        // Send a message around the listener will exchange the 2 floors for us
        eventsManager.instance.dispatch(Events.FLOOR_SWAP, {
            floorA: floorIdA,
            floorB: floorIdB
        });
    };

    /**
     * Change current floor / the currently visualised floor is changing
     * @param floorId
     */
    changeFloor(floorId: number) {
        // Send a message around the listener will change the current floor for us
        eventsManager.instance.dispatch(Events.FLOOR_CHANGE, floorId);
        // Reinit current combo box
        this._initFloorCombo(this.floors, floorId);
    };

    /**
     * Add floor to the current scene (up or down)
     * @param isUp
     */
    addFloor(isUp: boolean) {
        // Send a message around the listener will add a new floor for us
        eventsManager.instance.dispatch(Events.FLOOR_ADD, isUp);
    };
}